import { useEffect, useMemo } from 'react';
import KeyboardUtil from '@modules/keyboard/KeyboardUtil';

export function useKeyboardEvents() {
  const keyboardUtil = useMemo(() => KeyboardUtil.getInstance(), []);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      keyboardUtil.handleKeyPress(e);
    };

    window.addEventListener('keydown', onKeyDown, { capture: true });

    return () => {
      window.removeEventListener('keydown', onKeyDown, { capture: true });
    };
  }, [keyboardUtil]);
}
